export default "__VITE_ASSET__81f5d61f__"